import { DollarCircleOutlined } from "@ant-design/icons";
import { Button, Card } from "antd";
import Image from "next/image";
import React from "react";
import LeftFeatureIcon1 from "@/public/images/landing/Left Feature Icon 1.webp";
import LeftFeatureIcon2 from "@/public/images/landing/Left Feature Icon 2.webp";
import RightFeatureIcon from "@/public/images/landing/Right Feature Icon.webp";
import LandingStudentStudying from "@/public/images/landing/family-sitting-on-sofa-laptop.webp";
import { Exam } from "@/enums/exam.enum";
import { IseeLevel } from "@/enums/isee-level.enum";

const HeroSection = ({ handleSignUpToNotify }) => {
  return (
    <section id="stedprep-hero-section" className="bg-[#F4F7FF] pt-6 pb-4">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="flex flex-col md:flex-row items-start gap-8 lg:gap-14">
          <div className="w-full lg:w-[50%] mb-8 lg:mb-0 pt-8">
            <div className="mb-5">
              <div className="inline-block bg-[#DBE2EF] border border-blue-100 rounded-md px-6 py-1.5">
                <span className="flex items-center text-blue-500 text-sm font-medium">
                  <DollarCircleOutlined className="text-[#DA7D00] mr-2 text-sm" />
                  {`Money-Back Guarantee`}
                </span>
              </div>
            </div>

            <h1 className="text-4xl md:text-4xl lg:text-6xl font-bold leading-[1.15] mb-7">
              <div className="block md:hidden text-[#2D68C4]">StedPrep </div>
              <div className="block md:hidden text-[#333]">
                AI-powered ISEE prep personalized for every student
              </div>

              <div className="hidden md:block text-[#2D68C4]">StedPrep</div>
              
              <div className="hidden md:block text-[#333]">AI-powered ISEE</div>
              <div className="hidden md:block text-[#333]">prep personalized</div>
              <div className="hidden md:block text-[#333]">for every student</div>
            </h1>

            <p className="text-gray-700 mb-8 max-w-xl leading-relaxed text-lg">
              {`Created by parents, designed by educators, and powered by
                   AI-personalized prep proven to raise scores.`}
            </p>

            {/* Previous code - opens modal
            <Button
              onClick={() => handleSignUpToNotify('join',{ exam: Exam.ISEE, examLevel: IseeLevel.MIDDLE_LEVEL })}
              type="primary"
              className="h-12 px-8 text-base font-medium rounded bg-[#2D68C4] hover:bg-[#2661c8] text-white border-none shadow-sm"
            >
              {`Sign Up to Notify`}
            </Button>
            */}
            {/* Updated to redirect to app */}
            <div className="flex flex-col items-start">
              <a
                href="https://app.stedprep.com/register"
                target="_blank"
                rel="noopener noreferrer"
              >
                <Button
                  type="primary"
                  className="h-12 px-8 text-base font-medium rounded bg-[#2D68C4] hover:bg-[#2661c8] text-white border-none shadow-sm"
                >
                  {`Take a free diagnostic test`}
                </Button>
              </a>
              <p className="text-xs text-gray-500 mt-2">No credit card required.</p>
            </div>
          </div>

          <div className="w-full lg:w-1/2 mt-16">
            <Image
              src={LandingStudentStudying}
              alt="Family studying together"
              className="w-full h-auto rounded-lg"
              priority
              width={722}
              height={470}
              fetchPriority="high"
            />
          </div>
        </div>

        <div className="text-center my-10 mt-20 mb-6">
          <p className="text-[#2D68C4] text-2xl lg:text-xl font-medium">
            {`Our technology enables every student to work at their zone of proximal `}
          </p>
          <p className="text-[#2D68C4] text-2xl lg:text-xl font-medium">{`development for 100+ micro skills`}</p>
        </div>

        <div className="flex flex-wrap justify-center gap-4 md:gap-6 lg:gap-8 mx-auto pb-12 -mt-16 mt-0 md:mt-4">
          <Card
            hoverable
            className="w-[300px] bg-white rounded-xl cursor-default shadow-lg p-4 lg:p-3"
            size="small"
          >
            <div>
              <div className="flex items-center mb-2">
                <Image
                  src={LeftFeatureIcon1}
                  alt="Micro skills tracking"
                  width={45}
                  height={45}
                  className="mr-3"
                />
                <h3 className="text-xl font-medium text-[#2D68C4]">
                  {`Precise skills tracking`}
                </h3>
              </div>
              <p className="text-gray-600 ml-[58px]">
                {`Track progress in real time.`}
              </p>
            </div>
          </Card>

          <Card
            hoverable
            className="w-[300px] bg-white rounded-xl cursor-default shadow-lg p-4 lg:p-3"
            size="small"
          >
            <div>
              <div className="flex items-center mb-2">
                <Image
                  src={LeftFeatureIcon2}
                  alt="ZPD micro skills"
                  width={45}
                  height={45}
                  className="mr-3"
                />
                <h3 className="text-xl font-medium text-[#2D68C4]">
                  {`Hyper-Personalized Study`}
                </h3>
              </div>
              <p className="text-gray-600 ml-[58px]">
                {`Understand where each student stands.`}
              </p>
            </div>
          </Card>

          <Card
            hoverable
            className="w-[300px] bg-white rounded-xl cursor-default shadow-lg p-4 lg:p-3 md:col-span-2 md:mx-auto md:max-w-sm lg:col-span-1 lg:mx-0 lg:max-w-none"
            size="small"
          >
            <div>
              <div className="flex items-center mb-2">
                <Image
                  src={RightFeatureIcon}
                  alt="Personalized Study"
                  width={45}
                  height={45}
                  className="mr-3"
                />
                <h3 className="text-xl font-medium text-[#2D68C4]">
                  {`Improvement, Guaranteed`}
                </h3>
              </div>
              <p className="text-gray-600 ml-[58px]">
                {`Stay on the fastest path to academic growth.`}
              </p>
            </div>
          </Card>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
